// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import {combineReducers} from 'redux';

import type {GenericAction} from 'mattermost-redux/types/actions';
import type {Channel} from 'mattermost-redux/types/channels';

import {ChannelTypes, UserTypes} from 'mattermost-redux/action_types';

function channels(state: string[] = [], action: GenericAction) {
    switch (action.type) {
    case ChannelTypes.RECEIVED_ALL_CHANNELS:
        // https://time-sentry.tinkoff.ru/organizations/sentry/issues/2659/
        if (!action.data?.map) {
            return state;
        }
        return action.data.map((v: Channel) => v.id);
    case UserTypes.LOGOUT_SUCCESS:
        return [];
    default:
        return state;
    }
}

export default combineReducers({
    channels,
});
